/* ===============================
   SHRINE PRO – GLOBAL HELPERS
   =============================== */

window.debounce = function (fn, wait = 300) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn.apply(this, args);
    }, wait);
  };
};

window.removeTrapFocus = function () {
  document.removeEventListener("focusin", window.trapFocusHandlers);
};

window.pauseAllMedia = function () {
  document.querySelectorAll('video, iframe').forEach((media) => {
    try {
      if (media.tagName === 'VIDEO') {
        media.pause();
      }

      if (media.tagName === 'IFRAME') {
        const src = media.src;
        media.src = src;
      }
    } catch (e) {
      // silent
    }
  });
};

// ================================
// AUTOPLAY INTERNAL SHOPIFY VIDEOS
// ================================

function prepareInternalVideo(container) {
  const video = container.querySelector('video');
  if (!video) return;

  if (video.dataset.prepared === "1") return;

  const sources = video.querySelectorAll('source[data-src]');
  sources.forEach(source => {
    if (!source.src) {
      source.src = source.dataset.src;
    }
  });

  video.muted = true;
  video.playsInline = true;
  video.setAttribute('playsinline', '');
  video.preload = 'auto';

  video.load();
  video.dataset.prepared = "1";
}

function playInternalVideo(container) {
  const video = container.querySelector('video');
  if (!video) return;

  prepareInternalVideo(container);

  if (video.paused) {
    video.play().catch(() => {});
  }
}

function pauseInternalVideo(container) {
  const video = container.querySelector('video');
  if (!video) return;

  if (!video.paused) {
    video.pause();
  }
}

// 👀 AUTOPLAY POR VISIBILIDAD (CLAVE)
const videoObserver = new IntersectionObserver(
  entries => {
    entries.forEach(entry => {
      const container = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
        playInternalVideo(container);
      } else {
        pauseInternalVideo(container);
      }
    });
  },
  { threshold: [0.6] }
);

// Iniciar observación
function initInternalVideos() {
  document.querySelectorAll('.internal-video').forEach(container => {
    videoObserver.observe(container);
  });
}

// Click manual (fallback)
document.addEventListener('click', function (e) {
  const playButton = e.target.closest('.internal-video__play');
  if (!playButton) return;

  const container = playButton.closest('.internal-video');
  if (!container) return;

  window.pauseAllMedia?.();
  playInternalVideo(container);
});

// Splide slide activo
document.addEventListener('splide:move', function () {
  document.querySelectorAll('.splide__slide.is-active .internal-video').forEach(container => {
    playInternalVideo(container);
  });
});

// DOM READY
document.addEventListener('DOMContentLoaded', function () {
  initInternalVideos();
});

